/* eslint-disable jsx-a11y/anchor-has-content,react/no-danger */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {trackEvent} from '../../helpers/listeners/analytics';
import {filterHeadline, filterHTML, filterResource, filterUrl, isInternalLink, stripTags} from "../../helpers/filters";
import {trackEventByUrl} from "../../helpers/events";
import ReactVideoModal from "../ReactVideoModal/ReactVideoModal";

interface Data {
    paragraphById: {
        fieldColorText: string;
        fieldColorBackground: string;
        fieldObjectImgMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: string;
                    height: string;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>;
        fieldTxtHeadline: string;
        fieldHtmlBody: Array<{
            value: string;
            format: string;
            processed: string;
        }>;
        fieldVarIsVideoLink: boolean;
        fieldVarLink: Array<{
            title: string;
            url: Array<{
                routed: string;
                path: string;
            }>;
        }>;
    }
}

class InnerCardHoverQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphInnerCardHover {
          fieldColorText
          fieldColorBackground
          fieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
            }
          }
          fieldTxtHeadline
          fieldHtmlBody {
            value
            format
            processed
          }
          fieldVarIsVideoLink
          fieldVarLink {
              url {
                routed
                path
              }
              title
          }
        }
      }
    }
  }
}
`;

class InnerCardHover extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        stylesObject: PropTypes.object,
        markComponentLoadedAs: PropTypes.func.isRequired,
        // eslint-disable-next-line react/no-unused-prop-types
        handleLoadedComponents: PropTypes.func.isRequired
    };

    static defaultProps = {
        stylesObject: {}
    };

    state = {
        modalOpen: false
    };

    openModal = (field, videoId, event) => {
        if (videoId) {
            event.preventDefault();
            event.stopPropagation();
            if (field && field.fieldTxtHeadline) {
                trackEvent('Video', 'Play', `${stripTags(field.fieldTxtHeadline)} - ${videoId.type}:${videoId.id}`);
            } else {
                trackEvent('Video', 'Play', `${document.title.split('|')[0].trim()} - ${videoId.type}:${videoId.id}`);
            }

            this.setState({modalOpen: true});
        }
    };

    render() {
        const {id, markComponentLoadedAs} = this.props;
        const inheritedStyles = this.props.stylesObject;
        return (
            <InnerCardHoverQuery asyncMode query={GET_COMPONENT} variables={{ id: this.props.id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;

                    let styles = {};
                    const overlayStyles = {};

                    if (field.fieldColorText) {
                        styles.color = field.fieldColorText;
                    }
                    if (field.fieldColorBackground) {
                        overlayStyles.backgroundColor = field.fieldColorBackground;
                    }
                    if (field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url) {
                        styles.background = `url('${filterResource(field.fieldObjectImgMedia.entity.fieldMediaImage.url)}') no-repeat center center`;
                        styles.backgroundSize = 'cover';
                    }

                    styles = {...styles, ...inheritedStyles};

                    const videoId = field.fieldVarIsVideoLink && field.fieldVarLink && field.fieldVarLink.url && field.fieldVarLink.url.path ? ReactVideoModal.getVideoId(field.fieldVarLink.url.path) : null;

                    markComponentLoadedAs(id, true);

                    let additionalClasses = '';
                    if (field.fieldVarIsVideoLink) {
                        additionalClasses += 'innerCardHoverVideo';
                    }

                    return (
                        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/no-static-element-interactions
                        <div className={`innerCardHover ${additionalClasses}`} style={styles}>

                            {videoId && (
                                <ReactVideoModal inline={false} uri={field.fieldVarLink.url.path} isOpen={this.state.modalOpen} onClose={() => this.setState({modalOpen: false})} />
                            )}
                            {videoId && field.fieldVarLink && field.fieldVarLink.url && (
                                <button className="videoButton innerCardHover__ItemLink"
                                   onClick={(e) => {
                                       trackEventByUrl(field.fieldVarLink.url.path, field.fieldTxtHeadline || 'View Video');
                                       this.openModal(field, videoId, e);
                                   }} />
                            )}
                            {!videoId && field.fieldVarLink && field.fieldVarLink.url && (
                                <a className="innerCardHover__ItemLink"
                                   onClick={() => trackEventByUrl(field.fieldVarLink.url.path, field.fieldTxtHeadline || 'Open Link')}
                                   href={filterUrl(field.fieldVarLink.url.path)}
                                   target={isInternalLink(field.fieldVarLink.url.path) ? null : '_blank'}
                                   rel={isInternalLink(field.fieldVarLink.url.path) ? null : 'noreferrer noopener'}/>
                            )}

                            {field.fieldVarIsVideoLink && (
                                <div className="innerCardHover__videoPlayButton">
                                    <svg enableBackground="new 0 0 85 85" viewBox="0 0 85 85" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><path d="m42.5 0c-23.5 0-42.5 19-42.5 42.5s19 42.5 42.5 42.5 42.5-19 42.5-42.5-19-42.5-42.5-42.5zm0 77.7c-19.5 0-35.2-15.7-35.2-35.2s15.7-35.2 35.2-35.2 35.2 15.7 35.2 35.2-15.7 35.2-35.2 35.2z"/><path d="m32.1 61.6 31.5-19.1-31.5-19.1z"/></g></svg>
                                </div>
                            )}
                            {field.fieldTxtHeadline && field.fieldTxtHeadline.trim().length ? (
                                <div className="innerCardHover__outerContent">
                                    <h3 className="innerCardHover__title" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                                </div>
                            ) : null}

                            <span className="innerCardHover__ItemOverlay" style={overlayStyles} />

                            <div className="innerCardHover__inner">
                                {field.fieldTxtHeadline && (
                                    // eslint-disable-next-line react/no-danger
                                    <h3 className="innerCardHover__innerTitle" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                                )}

                                {field.fieldHtmlBody && field.fieldHtmlBody.processed && (
                                    // eslint-disable-next-line react/no-danger
                                    <div className="innerCardHover__ItemBody" dangerouslySetInnerHTML={{__html: filterHTML(field.fieldHtmlBody.processed)}}/>
                                )}

                            </div>

                            {videoId && (
                                 <div className="innerCardHover__overlayPlay">
                                    <svg enableBackground="new 0 0 85 85" viewBox="0 0 85 85" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><path d="m42.5 0c-23.5 0-42.5 19-42.5 42.5s19 42.5 42.5 42.5 42.5-19 42.5-42.5-19-42.5-42.5-42.5zm0 77.7c-19.5 0-35.2-15.7-35.2-35.2s15.7-35.2 35.2-35.2 35.2 15.7 35.2 35.2-15.7 35.2-35.2 35.2z"/><path d="m32.1 61.6 31.5-19.1-31.5-19.1z"/></g></svg>
                                </div>
                            )}

                        </div>
                    );
                }}
            </InnerCardHoverQuery>
        )
    }
}

export default InnerCardHover;



// WEBPACK FOOTER //
// ./frontend/components/HoverCards/InnerCardHover.jsx